import { Component, Input } from '@angular/core';

export enum IconTypes {
  Add = 'add',
  Configure = 'configure',
  Trash = 'trash',
  BulletList = 'bullet-list',
  Play = 'vid-play',
  Stop = 'single-column',
  Shortcut = 'shortcut',
  Group = 'group',
  ArrowLeftCircle = 'arrow-left-circle',
  InfoFilled = 'info-filled',
  Refresh = 'refresh',
  Warning = 'warning',
  Link = 'link',
  Unlink = 'unlink'
}

@Component({
  selector: 'app-icon',
  template: `
    <span class="aui-icon aui-icon-{{ size }} aui-iconfont-{{ type }} {{ classNames }}">Alternative Text</span>
  `,
})
export class IconComponent {
  @Input() type = '';
  @Input() size = 'small';
  @Input() classNames = '';
}
